(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@sm360/widget-commons-general"), require("immutable"), require("react"));
	else if(typeof define === 'function' && define.amd)
		define("commons-configs", ["@sm360/widget-commons-general", "immutable", "react"], factory);
	else if(typeof exports === 'object')
		exports["commons-configs"] = factory(require("@sm360/widget-commons-general"), require("immutable"), require("react"));
	else
		root["CommonsConfigs"] = factory(root["CommonsGeneral"], root["Immutable"], root["React"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__sm360_widget_commons_general__, __WEBPACK_EXTERNAL_MODULE_immutable__, __WEBPACK_EXTERNAL_MODULE_react__) {
return 